module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "enter registration cover"
  }, [_c('div', {
    staticClass: "enter__outer"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('div', {
    staticClass: "enter__inner"
  }, [_c('form', {
    staticClass: "enter-form registration__form",
    attrs: {
      "id": "entry_form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_c('input-phone', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.resetPassword.isForgot),
      expression: "!resetPassword.isForgot"
    }],
    attrs: {
      "user": _vm.user,
      "placeholder": 'Введите номер телефона',
      "required": ""
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.resetPassword.isForgot),
      expression: "!resetPassword.isForgot"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }],
    staticClass: "enter-text-field",
    attrs: {
      "type": "password",
      "placeholder": "Пароль"
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "password", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.resetPassword.isForgot),
      expression: "!resetPassword.isForgot"
    }],
    staticClass: "enter-form__button",
    attrs: {
      "type": "submit",
      "value": "Войти"
    }
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": '/register'
    }
  }, [_c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.resetPassword.isForgot),
      expression: "!resetPassword.isForgot"
    }],
    staticClass: "enter-form__link"
  }, [_vm._v("Регистрация нового пользователя")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.resetPassword.isForgot),
      expression: "!resetPassword.isForgot"
    }],
    staticClass: "enter-form__link",
    on: {
      "click": _vm.forgotPassword
    }
  }, [_vm._v("\n\t\t\t\t\t\tЗабыли пароль?\n\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.resetPassword.isForgot),
      expression: "resetPassword.isForgot"
    }]
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.resetPassword.steps == 'first'),
      expression: "resetPassword.steps == 'first'"
    }]
  }, [_c('p', {
    staticClass: "enter__text"
  }, [_vm._v("* На указаный номер телефона будет выслан проверочный код")]), _vm._v(" "), _c('input-phone', {
    attrs: {
      "user": _vm.user
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "enter-form__button",
    attrs: {
      "type": "button",
      "value": "Отправить"
    },
    on: {
      "click": function($event) {
        _vm.sendRestorePhoneForRestorePass(_vm.user.phone)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.resetPassword.steps == 'two'),
      expression: "resetPassword.steps == 'two'"
    }]
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.confirmCode),
      expression: "confirmCode"
    }],
    staticClass: "enter-text-field",
    attrs: {
      "type": "text",
      "placeholder": "Введите код с сообщения"
    },
    domProps: {
      "value": (_vm.confirmCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.confirmCode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "enter-form__button",
    attrs: {
      "type": "button",
      "value": "Отправить"
    },
    on: {
      "click": function($event) {
        _vm.sendConfirmationCode(_vm.confirmCode)
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.resetPassword.steps == 'three'),
      expression: "resetPassword.steps == 'three'"
    }]
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPasswords.pass),
      expression: "newPasswords.pass"
    }],
    staticClass: "enter-text-field",
    attrs: {
      "type": "password",
      "placeholder": "Введите новый пароль"
    },
    domProps: {
      "value": (_vm.newPasswords.pass)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newPasswords, "pass", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPasswords.rePass),
      expression: "newPasswords.rePass"
    }],
    staticClass: "enter-text-field",
    attrs: {
      "type": "password",
      "placeholder": "Повторите ввод"
    },
    domProps: {
      "value": (_vm.newPasswords.rePass)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newPasswords, "rePass", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "enter-form__button",
    attrs: {
      "type": "button",
      "value": "Изменить пароль"
    },
    on: {
      "click": function($event) {
        _vm.changePassword(_vm.newPasswords.pass, _vm.newPasswords.rePass)
      }
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "enter-form__link",
    on: {
      "click": _vm.goToLogin
    }
  }, [_vm._v("Назад")])])], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "enter__inner registration__enter-inner"
  }, [_c('div', {
    staticClass: "main-logo registration__logo"
  }, [_c('img', {
    staticClass: "main-logo__item",
    attrs: {
      "src": require("../../assets/img/logo.png"),
      "alt": "logo"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-54e998ee"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/App/Login.vue
// module id = 616
// module chunks = 0